import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { COLORS } from "../config/theme/baseTheme";
import {
  chipFilterStyles,
  excelDownloadStyles,
  useDialogPaperPropsRootStyle,
  usePublishRouteDialogStyle,
  rootSectionWithContainer,
  orderTag
} from "SharedComponent/styles/sharedStyles";

export const useStyles = makeStyles((theme: Theme) => {
  const {
    publishDialogPaperPropsRoot,
    deleteDialogPaperPropsRoot,
    hubSelectionDialogPaperPropsRoot,
  } = useDialogPaperPropsRootStyle(theme);

  const {
    hubSelectionDialogTitle,
    hubSelectionDialogContentContainer,
    publishDialogButtonsContainer,
    deleteDialogButtonsContainer,
    hubSelectionDialogButtonsContainer,
    deleteDialogContentContainer,
    publishErrorPopupContainer,
  } = usePublishRouteDialogStyle(theme);

   const {
      excelDownloadStatus,
      excelDownloadStatusText,
      checkedIconStyle,
      close,
      closeIcon,
      excelDownloadError,
      button,
      colSettings,
      buttonContainer,
    } = excelDownloadStyles(theme);

  return createStyles({
    ...rootSectionWithContainer(theme),
    tabPanelContainer: {
      flexDirection: "column",
      height: "100%",
      "& .panelItem": {
        width: "100%",
        "&.chipFilter": {
          padding: "16px 16px 16px 0px",
          "& .chipsContainer": {
            display: "flex",
            justifyContent: "space-between",
            "& .chipFilterItem": {
              height: 36,
              minWidth: "11%",
              ...chipFilterStyles(theme),
            },
          },
        },
        "&.gridWrapper": {
          height: "calc(100% - 98px)",
          "& .idLink": {
            cursor: "pointer",
            color: theme.palette.primary.main,
            fontWeight: 600,
            fontSize: 12,
          },
          "& .actionsLink": {
            cursor: "pointer",
            color: theme.palette.primary.main,
            fontWeight: 600,
            fontSize: 14,
          },
          "& .multiple": {
            color: "#2D2D2D",
            fontWeight: 500,
            fontSize: 12,
            textTransform: "capitalize",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        },
      },
    },
    publishDialogPaperPropsRoot,
    deleteDialogPaperPropsRoot,
    hubSelectionDialogPaperPropsRoot,
    hubSelectionDialogTitle,
    hubSelectionDialogContentContainer,
    publishDialogButtonsContainer,
    deleteDialogButtonsContainer,
    hubSelectionDialogButtonsContainer,
    deleteDialogContentContainer,
    publishErrorPopupContainer,
    actionsHeader: {
      alignItems: "center",
      "& .actionItem": {
        cursor: "pointer",
        "& .icon": {
          padding: theme.spacing(0.25),
          "&.editIcon": {
            marginRight: theme.spacing(0.75),
          },
        },
      },
    },
    deliveryAreaHeader: {
      alignItems: "center",
      "& .columnValue": {
        fontSize: 12,
      },
    },
    statusHeaderContainer: {
      "& .tag": {
        ...orderTag(theme),
        "&.INFO_BLUE": {
          borderColor: COLORS.INFO_BLUE,
          color: COLORS.INFO_BLUE,
        },
        "&.SEA_GREEN": {
          borderColor: COLORS.SEA_GREEN,
          color: COLORS.SEA_GREEN,
        },
        "&.OCEAN_GREEN": {
          borderColor: COLORS.OCEAN_GREEN,
          color: COLORS.OCEAN_GREEN,
        },
        "&.GOLDEN_BELL": {
          borderColor: COLORS.GOLDEN_BELL,
          color: COLORS.GOLDEN_BELL,
        },
        "&.GREY_SCALE": {
          borderColor: COLORS.GREY_SCALE,
          color: COLORS.GREY_SCALE,
        },
      },
    },
    excelDownloadStatus,
    excelDownloadStatusText,
    checkedIconStyle,
    close,
    closeIcon,
    excelDownloadError,
    button,
    colSettings,
    buttonContainer,
  });
});
